/**
 * AES+RSA加解密工具类
 */
import Vue from "vue";
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";


/**
 * AES加密
 *
 * @param word 加密内容
 * @param keyStr 十六位的十六进制数作为 加解密的密钥，一般是动态生成（这里由randomString方法生成）
 */
export function AesEncrypt(word, keyStr) {
    keyStr = keyStr ? keyStr : "abcdefgabcdefg12";
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

//AES解密
export function AesDecrypt(word, keyStr) {
    keyStr = keyStr ? keyStr : "abcdefgabcdefg12";
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

// 生成16位随机字符串
export function randomString(len) {
  len = len || 16;
  /*默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1*/
  var $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  var maxPos = $chars.length;
  var randomKey = "";
  for (var i = 0; i < len; i++) {
    randomKey += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return randomKey;
}

/**
 * AES加密
 * 用随机生成的randomKey加密  得到密文
 *
 * @param content 原文
 * @param randomKey 16位随机密钥
 */


export function getAESEncryption(content, randomKey) {
    var encryption = AesEncrypt(content, randomKey);
    // console.log("加密后：" + encryption);
    return encryption;
}

/**
 * AES解密
 * 根据返回的aeskey 解密  得到原文
 *
 * @param content 密文
 * @param aeskey  请求接口后返回的密钥
 */
export function getAESDecryption(content, aeskey) {
    var decryption = AesDecrypt(content, aeskey);
    // console.log("解密后：" + decryption);
    return decryption;
}

//keys
//  RSA服务端公钥
let serverPubkey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDZJBxMWPcuApyJXJR1XWF+t7++3uk5cTwgBfYbd6undz30/jvvYRil10ogxeJYQM8fG9orLN2eqjENK7OcD/HzTyLBrC5cZT6+6iwnIO5ewT9BQ38SrHNQy+xM7NHHHo44Z2vZCE1OL/67agROp//iZGzx3hMVWaU1kXBW8yuW4QIDAQAB`;

//  RSA本地公钥
let localPubkey= "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCeIEmoXbOZvgCNV67/W/nY2EUfnGX7oKXWqs4Vi4evSvivjNHQAJcqlsj4illtEb0HQWsKtANvSRikdyo9tTiSIsZGB1ocqiYKGXELxgKGm7kWVQh0ZF7XJpF76P29ijUh2fWSiCciOlV11chvDquvdXMNroy+r3LCr8OmmFu6XwIDAQAB";

//   RSA本地私钥
let localPrivatekey = "MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBAJ4gSahds5m+AI1Xrv9b+djYRR+cZfugpdaqzhWLh69K+K+M0dAAlyqWyPiKWW0RvQdBawq0A29JGKR3Kj21OJIixkYHWhyqJgoZcQvGAoabuRZVCHRkXtcmkXvo/b2KNSHZ9ZKIJyI6VXXVyG8Oq691cw2ujL6vcsKvw6aYW7pfAgMBAAECgYANwpOGUjkZzN3xbsrsr81LIG7LdGmvfuhPiOeMGmtBRs3jQObVKef9rcdpUWi8xAlmAzxUXxvZaEv7q98CJa35boDH0teVZUaeJsttBEh0BX/JsirR8FUB6G2L8/EuwmgWEMNpZos67inamwWLs4qDskwh160P3330qFEGGuiP+QJBANDRZ4wWfsd6x3WU8W3qpFXEBiVrQMcrdFUg8FuMhckO7nUodTr+0lScik1I7+OIhXjjmywZQSkX5vfOloFdNBMCQQDB2rqtYvA3r//TxmKgvzcR8JxJFnDs1erELVRoRLOe5/bBhQ+RRSd62iXk30G2SFI3GlOXA7FkKE6TkR8s6jIFAkBs94lYUfjQcaKaGiIuYI5m7wbiCejgxi1LqweiTl8V/0OyQW2DXqw1WQbWs6PzES/NWMCFr5wQLJfrYpOpaBCfAkBuxZcQhs2vdJGiKOWo5zsHtE8J8Jncq6w4J5Lo9gER14kIMgmgQDz8FXW739tD1vWr6Q5E5+ZQzjuAVVfUKYslAkBxP6UyehNaWS5Sa3BqPybflaw+1QENB34s8OwBPPwkh1dtHrfATojX6piPql4MqOYEbooX7MVqLzW9T7yu9bDK";


/**
 * RSA加密
 *
 * @param data 加密内容
 */



export const $rsaEncrypt =  (data) => {

 let jse = new JSEncrypt();
    // 加密用的是服务端公钥serverPubkey
    jse.setPublicKey(serverPubkey);

    let paramsData = ""; //加密后的参数
    let paramsString = ""; //把传过来的data数据转成字符串
    let params1 = ""; //把paramsString每三十个字符截取一次赋值给params1
    let params2 = ""; //把params1循环加密赋值给params2
    if (data) {
        paramsString = JSON.stringify(data);
    }
    // 加密内容超长需要分组加密
    if (paramsString.length > 30) {
        params1 = paramsString.match(/.{1,30}/g);
        params1.forEach(function(d) {
            let params3 = jse.encrypt(d);
            params2 += params3;
        });
        paramsData = params2;
        return paramsData;
    } else {
        //无需分组加密可直接用encrypt方法
        return jse.encrypt(data);
    }
}

// Vue.prototype.$rsaEncrypt = function(data) {
//     let jse = new JSEncrypt();
//     // 加密用的是服务端公钥serverPubkey
//     jse.setPublicKey(serverPubkey);

//     let paramsData = ""; //加密后的参数
//     let paramsString = ""; //把传过来的data数据转成字符串
//     let params1 = ""; //把paramsString每三十个字符截取一次赋值给params1
//     let params2 = ""; //把params1循环加密赋值给params2
//     if (data) {
//         paramsString = JSON.stringify(data);
//     }
//     // 加密内容超长需要分组加密
//     if (paramsString.length > 30) {
//         params1 = paramsString.match(/.{1,30}/g);
//         params1.forEach(function(d) {
//             let params3 = jse.encrypt(d);
//             params2 += params3;
//         });
//         paramsData = params2;
//         return paramsData;
//     } else {
//         //无需分组加密可直接用encrypt方法
//         return jse.encrypt(data);
//     }
// };




/**
 * RSA解密
 *
 * @param data 解密内容
 */
// Vue.prototype.$rsaDecrypt = function(data) {
//     let jse = new JSEncrypt();
//     // 解密密用的是本地私钥localPrivatekey
//     jse.setPrivateKey(localPrivatekey);
//     return jse.decrypt(data);
// };

export const $rsaDecrypt = function (data) {
    let jse = new JSEncrypt();
    jse.setPrivateKey(localPrivatekey);
    return jse.decrypt(data);
}



// WEBPACK FOOTER //
// ./src/config/encryptionUtil.js